import { Suspense, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

interface IconSpriteProps {
  spriteId: string;
  content: React.ReactNode;
}

const IconSprite: React.FC<IconSpriteProps> = ({ spriteId, content }) => {
  useEffect(() => {
    const spriteEl = document.getElementById(spriteId);

    if (!spriteEl) {
      // generate span
      const span = document.createElement('span');
      span.id = spriteId;
      span.style.display = 'none';
      document.body.appendChild(span);

      // generate content
      const tempContainer = document.createElement('div');
      const root = createRoot(tempContainer);

      new Promise<void>((resolve) => {
        root.render(<Suspense fallback={<div></div>}>{content}</Suspense>);

        // Poll for content until it's fully loaded
        const checkLoaded = setInterval(() => {
          if (tempContainer.innerHTML.trim() !== '<div></div>') {
            // add content into span
            span.innerHTML = tempContainer.innerHTML.trim();
            clearInterval(checkLoaded);
            root.unmount();
            resolve();
          }
        }, 50); // Check every 50ms
      });
    }
  }, [content]);

  return null;
};

export default IconSprite;
